<template>
  <div :class="className">
    <v-tooltip
      content-class="vc-tooltip"
      max-width="288"
      :ripple="false"
      color="#ffffff"
      bottom>
      <template v-slot:activator="{ on }">
        <v-btn class="vc-tooltip-btn" icon v-on="on">
          <span class="icon-Qmark2"></span>
        </v-btn>
      </template>
      <div>
        <div class="vc-tooltip-title">{{content.title}}</div>
        <div v-html="content.text" class="vc-tooltip-text"></div>
      </div>
    </v-tooltip>
  </div>
</template>
<script>

  export default {
    name: "Tooltip",
    props: ['content','className'],
  };
</script>
<style scoped lang="scss">
  @import "@/assets/scss/abstract/_variables.scss";
  @import "@/assets/scss/abstract/_mixins.scss";

  .icon-Qmark2{
    font-size: 18px;
    opacity: 0.3;
    color: #000000;
  }

  .vc-tooltip{
    color: #000000;
    background: yellow;
    padding: 0px;
    font-size: 12px;
    opacity: 1 !important;
    border-radius: 4px;
    box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.2);

    .vc-tooltip-title{
      height: 49px;
      line-height: 30px;
      background-color: #e9eefa;
      padding: 10px;
      font-family: var(--font3);
      font-weight: bold;
    }

    .vc-tooltip-text{
      font-weight: 400;
      font-size: 12px;
      line-height: 1.5;
      letter-spacing: 0.2px;
      color: rgba(0, 0, 0, 0.79);
      padding: 10px;
    }
  }
</style>
